import React from "react";
import "../../assets/styles/footer.css";

const Footer = () => {
  return (
    <footer
      className="footer text-light py-5"
      style={{ backgroundColor: "#18181C" }}
    >
      <div className="container">
        {/* Flex column for mobile, row with space for desktop */}
        <div className="row d-flex flex-column flex-md-row gap-md-5">
          {/* Column 1 - Singapore Section (First on Mobile & Desktop) */}
          <div className="col-12 col-md-4 mb-4 me-md-5 order-1">
            <h5 style={{ color: "#9DFF00" }}>commceed SINGAPORE PTE LTD.</h5>
            <ul className="list-unstyled">
              <li style={{ fontSize: "17px" }}>IC Anson Road,</li>
              <li style={{ fontSize: "17px" }}>#22 -02,</li>
              <li style={{ fontSize: "17px" }}>International Place</li>
              <li style={{ fontSize: "17px" }}>Singapore 079903</li>
            </ul>
          </div>

          {/* Column 2 - Australia Section (Second on Mobile) */}
          <div className="col-12 col-md-5 mb-4 order-2">
            <h5 style={{ color: "#9DFF00" }}>commceed AUSTRALIA PTY LTD</h5>
            <ul className="list-unstyled">
              <li>
                <a href="#" className="text-light" style={{ fontSize: "17px" }}>
                  Suite 648, 44 Lakeview Drive
                </a>
              </li>
              <li>
                <a href="#" className="text-light" style={{ fontSize: "17px" }}>
                  Scoresby,
                </a>
              </li>
              <li>
                <a href="#" className="text-light" style={{ fontSize: "17px" }}>
                  VIC 3179
                </a>
              </li>
              <li>
                <a href="#" className="text-light" style={{ fontSize: "17px" }}>
                  Australia.
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact Section (At bottom on mobile, column on desktop) */}
          <div className="col-12 col-md-5 mb-4 order-3">
            <div className="social-icons">
              <h5 style={{ paddingTop: "40px", color: "#9DFF00" }}>
                CONTACT US
              </h5>
              <ul
                className="list-unstyled"
                style={{ paddingLeft: "20px", listStyleType: "disc" }}
              >
                <li style={{ fontSize: "17px" }}>
                  <span style={{ minWidth: "95px" }}>Office</span>: +61 3 8564
                  8530
                </li>
                <li style={{ fontSize: "17px" }}>
                  <span style={{ minWidth: "95px" }}>Sales</span>: +61 478 97
                  6061
                </li>
                <li style={{ fontSize: "17px" }}>
                  <span style={{ minWidth: "95px" }}>WhatsApp</span>: +61 478 97
                  6061
                </li>
              </ul>

              <a href="#" className="me-3 instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#" className="me-3 facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" className="me-3 twitter">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#" className="whatsapp">
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
